export enum FtmSettingsMessages {
  SUBHEADING_FLEXTIME_TITLE = 'FlexTime Settings',
  FTM_TEACHERS_ENABLE = 'Enable FlexTime for teachers',
  FTM_STAFF_ENABLE = 'Enable FlexTime for staff',
  FTM_KIOSK_ENABLE = 'Enable FlexTime check in kiosk',
  FTM_AUTO_END_HALL_PASS_ON_CHECK_IN = 'Auto-end hall pass on check in',
  FTM_AUTO_END_HALL_PASS_ON_CHECK_IN_TOOLTIP = 'Active hall passes will automatically end when the user is checked in to an activity',
  FTM_AUTO_ASSIGN_BEHAVIOR = 'Auto assign behavior on tardy check in',
  FTM_AUTO_ASSIGN_BEHAVIOR_TOOLTIP = 'Users checked in as tardy will automatically be assigned a behavior',
  FTM_AUTO_ASSIGN_SELECT_PLACEHOLDER = 'Auto assign behavior',
  FTM_AUTO_ASSIGN_DISABLED_LABEL = 'This behavior is currently disabled',
  FTM_ENABLE_TARDY_CHECK_IN = 'Enable tardy check in',
  FTM_RESTRICT_CHECK_IN_TIMES = 'Restrict check in times',
  FTM_RESTRICT_CHECK_IN_TIMES_TOOLTIP = 'If enabled, users can only check into an activity within 10 minutes before or after the scheduled time',
}
